import { action } from '@ember/object';
import { capitalize } from '@ember/string';

import { SheetColumnType } from 'webapp/enums/enums';
import SheetSelection from 'webapp/utils/sheet-selection';

import type { ColorSelection } from 'webapp/components/custom-query/setup/sheet/preview';
import CustomQuerySetupSheetPreviewComponent from 'webapp/components/custom-query/setup/sheet/preview';

export default class CustomQuerySetupWizardSheetPreviewComponent extends CustomQuerySetupSheetPreviewComponent {
	override skipCustomBorders = true; // for performance reasons

	override get activeColorSelections(): ColorSelection[] {
		// filter out only for this activeSheet
		const colorSelections: ColorSelection[] = [];
		Object.keys(this.activeSheet.columnTypes).forEach((column) => {
			const columnData = this.activeSheet.columnTypes[column]!,
				color = this.args.model.getColorForA1Field(columnData.type);
			if (color) {
				const range = `${column}:${column}`;
				colorSelections.push({
					color,
					range,
				});
			}
		});
		return colorSelections;
	}

	@action
	override colHeaderFormatter(idx: number): string {
		const a1 = SheetSelection.transformColumnIndexToA1(idx),
			type = this.activeSheet.columnTypes[a1]?.type;

		let label;
		if (type) {
			const typeString = type === SheetColumnType.METRIC ? 'value' : type;
			label = `<span class="colLabel label--${type}">${a1}<label>${capitalize(typeString)}</label></span>`;
		} else {
			label = a1;
		}
		return label;
	}
}
